import { Injectable } from "@angular/core";

import { isNumeric } from "rxjs/internal-compatibility";

import { QueryStringSerializationService } from "../../../../shared-library/services/environment/query-string-serialization.service";

import { SearchTabAlias } from "../../../enums/search-tab-alias.enum";

import { SearchParametersModel } from "../models/search-parameters.model";
import { SearchTabConfigModel } from "../models/search-tab-config.model";
import { SlimQueryStringSerializationService } from "../../../services/slim-query-string-serialization.service";

@Injectable({
    providedIn: "root"
})
export class ContentSearchParametersFactoryService {
    public constructor(
        private _serializationService: QueryStringSerializationService,
        private _slimSerializationService: SlimQueryStringSerializationService
    ) {
    }

    public createFromQueryString(queryString: string, searchTabConfig: SearchTabConfigModel): SearchParametersModel {
        const rawValues = this._serializationService.deserialize<SearchParametersModel>(queryString);
        const parsedValues = new SearchParametersModel();

        parsedValues.searchTab = searchTabConfig.tabAlias;
        parsedValues.searchContext = searchTabConfig.contentSearchContext;
        parsedValues.searchText = (rawValues.searchText || "").replace(/(\+)+/gi, " ");

        if (rawValues.searchTab === SearchTabAlias.CONTENT_SEARCH) {
            parsedValues.sortOption = rawValues.sortOption || "0";
            parsedValues.pageNumber = (rawValues.pageNumber > 0) ? Number(rawValues.pageNumber) : 1;
            parsedValues.pageSize = ((rawValues.pageSize > 0) && (rawValues.pageSize <= 100)) ? Number(rawValues.pageSize) : 10;

            if (!isNumeric(parsedValues.sortOption)) {
                parsedValues.sortOption = "0";
            }
        } else {
            parsedValues.sortOption = "0";
            parsedValues.pageNumber = 1;
            parsedValues.pageSize = 10;
        }

        return parsedValues;
    }

    public serialiseToQueryString(searchParams: SearchParametersModel): string {
        return this._serializationService.serialize(searchParams);
    }
}
